export default function ExpandTagsIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.5 15C10.8125 15 12.9375 13.7812 14.125 11.75C15.2812 9.75 15.2812 7.28125 14.125 5.25C12.9375 3.25 10.8125 2 8.5 2C6.15625 2 4.03125 3.25 2.84375 5.25C1.6875 7.28125 1.6875 9.75 2.84375 11.75C4.03125 13.7812 6.15625 15 8.5 15ZM8.5 0.5C11.3438 0.5 13.9688 2.03125 15.4062 4.5C16.8438 7 16.8438 10.0312 15.4062 12.5C13.9688 15 11.3438 16.5 8.5 16.5C5.625 16.5 3 15 1.5625 12.5C0.125 10.0312 0.125 7 1.5625 4.5C3 2.03125 5.625 0.5 8.5 0.5ZM4.71875 8.03125C4.40625 7.75 4.40625 7.28125 4.71875 7C5 6.6875 5.46875 6.6875 5.78125 7L8.5 9.71875L11.2188 7C11.5 6.6875 11.9688 6.6875 12.2812 7C12.5625 7.28125 12.5625 7.75 12.2812 8.03125L9 11.2812C8.71875 11.5938 8.25 11.5938 7.96875 11.2812L4.71875 8.03125Z"
        fill="#6B6255"
      />
    </svg>
  );
}
